/* Bloqueo de copia de imágenes y videos (pedido de Kevin, 1-oct-2026).
   Frena clic derecho, arrastre y el menú de «guardar imagen» al dejar el dedo presionado.
   No impide capturas de pantalla. Para quitarlo: borrar la línea de me-protege.js en sections/me-colors.liquid. */
(function(){
  if(window.__meProtege)return;window.__meProtege=!0;
  var css="img,video,picture,svg image{-webkit-touch-callout:none;-webkit-user-drag:none;-webkit-user-select:none;user-select:none}";
  var st=document.createElement("style");st.textContent=css;document.head.appendChild(st);
  function esMedio(e){
    var t=e.target;
    if(!t||!t.closest)return!1;
    if(t.closest("input,textarea,select,[contenteditable]"))return!1;
    if(t.closest("img,video,picture,canvas"))return!0;
    /* imagen debajo de una capa (carrusel, enlaces, fondos) */
    var els=document.elementsFromPoint?document.elementsFromPoint(e.clientX,e.clientY):[];
    for(var i=0;i<els.length&&i<6;i++){
      var n=els[i],tag=n.tagName;
      if(tag==="IMG"||tag==="VIDEO"||tag==="CANVAS")return!0;
      var bg=getComputedStyle(n).backgroundImage;
      if(bg&&bg.indexOf("url(")>-1)return!0;
    }
    return!1;
  }
  document.addEventListener("contextmenu",function(e){esMedio(e)&&e.preventDefault()},!0);
  document.addEventListener("dragstart",function(e){var t=e.target;t&&t.closest&&t.closest("img,video,picture,a img")&&e.preventDefault()},!0);
  function videos(){
    document.querySelectorAll("video").forEach(function(v){
      v.setAttribute("controlsList","nodownload noremoteplayback");
      v.setAttribute("disablePictureInPicture","");
    });
  }
  document.readyState!=="loading"?videos():document.addEventListener("DOMContentLoaded",videos);
  window.addEventListener("load",videos);
})();
